import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const checkNotario = async (userId, token) => {
    try {
      const response = await axios.get('https://auditoria.tramites.notaria4otavalo.com.ec/api/users/notario/', {
        headers: { Authorization: `Bearer ${token}` },
        params: { user_id: userId },
      });
      return response.data.length > 0;
    } catch (error) {
      console.error('Error checking notario status:', error);
      if (error.response && error.response.status === 401) {
        handleAuthError();
      }
      return false;
    }
  };

  const checkContador = async (userId, token) => {
    try {
      const response = await axios.get('https://auditoria.tramites.notaria4otavalo.com.ec/api/users/contador/', {
        headers: { Authorization: `Bearer ${token}` },
        params: { user_id: userId },
      });
      return response.data.length > 0;
    } catch (error) {
      console.error('Error checking contador status:', error);
      if (error.response && error.response.status === 401) {
        handleAuthError();
      }
      return false;
    }
  };

  const handleAuthError = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    setLoading(false);
    navigate('/login');
  };

  const login = async (token) => {
    try {
      localStorage.setItem('token', token);
      const response = await axios.get('https://auditoria.tramites.notaria4otavalo.com.ec/api/users/me/', {
        headers: { Authorization: `Bearer ${token}` },
      });
      const userData = response.data;

      const isNotario = await checkNotario(userData.id, token);
      const isContador = await checkContador(userData.id, token);

      const enhancedUser = {
        ...userData,
        is_notario: isNotario,
        is_contador: isContador,
      };

      setUser(enhancedUser);
      setLoading(false);
    } catch (error) {
      console.error('Error during login:', error);
      handleAuthError();
    }
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          setLoading(false);
          return;
        }

        const response = await axios.get('https://auditoria.tramites.notaria4otavalo.com.ec/api/users/me/', {
          headers: { Authorization: `Bearer ${token}` },
        });
        const userData = response.data;

        const isNotario = await checkNotario(userData.id, token);
        const isContador = await checkContador(userData.id, token);

        const enhancedUser = {
          ...userData,
          is_notario: isNotario,
          is_contador: isContador,
        };

        setUser(enhancedUser);
      } catch (error) {
        console.error('Error fetching user data:', error);
        handleAuthError();
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [navigate]);

  return (
    <AuthContext.Provider value={{ user, loading, login }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);